import { Converter } from '../types/converter';

export const heatDensityConverter: Converter = {
  id: 'heatDensity',
  name: 'Heat Density Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // Base SI unit
    { name: 'Joule/Square Meter', symbol: 'J/m²', factor: 1 },
    
    // Calorie-based units
    { name: 'Calorie (th)/Square Centimeter', symbol: 'cal (th)/cm²', factor: 41840 },
    
    // Langley unit
    { name: 'Langley', symbol: 'ly', factor: 41840 },
    
    // BTU-based units
    { name: 'Btu (IT)/Square Foot', symbol: 'Btu (IT)/ft²', factor: 11356.53 },
    { name: 'Btu (th)/Square Foot', symbol: 'Btu (th)/ft²', factor: 11348.93 }
  ]
};
